export default __webpack_public_path__ + "static/media/Fexocon-120-ban.e153feba.jpg";